function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return _get(target, property, receiver || target); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import './index.scss';
import 'js-events';
import 'scrolling-retainer';
import CustomHTMLElement from 'html-element';

var DropDown = /*#__PURE__*/function (_CustomHTMLElement) {
  _inherits(DropDown, _CustomHTMLElement);

  var _super = _createSuper(DropDown);

  function DropDown() {
    _classCallCheck(this, DropDown);

    return _super.apply(this, arguments);
  }

  _createClass(DropDown, [{
    key: "_runSetup",
    value: function _runSetup() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      _get(_getPrototypeOf(DropDown.prototype), "_runSetup", this).call(this);

      if (options.anchor && options.menu) {
        this.anchor = options.anchor;
        this.menu = options.menu;
        this.appendChild(this.anchor);
        this.appendChild(this.menu);
      } else {
        this.anchor = this.querySelector('.dropdown__anchor');
        this.menu = this.querySelector('.dropdown__menu');
      }

      this.menuActive = false;
      this.setupEvents();
    }
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      this.removeWindowBoundEventListener('resize');
      this.removeDocumentBoundEventListener('scrolling-retainer:released');
    } ////////// Events

  }, {
    key: "setupEvents",
    value: function setupEvents() {
      var _this = this;

      this.anchor.addEventListener('click', function (_event) {
        return _this.toggleMenu();
      });
      this.menu.querySelectorAll('a[href]').forEach(function (item) {
        return item.addEventListener('click', function (_event) {
          return _this.hideMenu();
        });
      });
      this.addWindowBoundEventListener('resize', this.documentResized);
      this.addDocumentBoundEventListener('scrolling-retainer:released', function (_event) {
        return _this.hideMenu();
      });
    }
  }, {
    key: "documentResized",
    value: function documentResized(_event) {
      if (!this.menuActive) {
        return;
      }

      this.updateHeight();
    }
  }, {
    key: "updateHeight",
    value: function updateHeight() {
      if (this.menu.classList.contains('dropdown__menu--up')) {
        this.menu.style.maxHeight = '';
        return;
      }

      var maxHeight = window.innerHeight - this.menu.getBoundingClientRect().top;
      this.menu.style.maxHeight = "".concat(maxHeight, "px");
    } ////////// State

  }, {
    key: "toggleMenu",
    value: function toggleMenu() {
      if (this.menuActive) {
        this.hideMenu();
      } else {
        this.showMenu();
      }
    }
  }, {
    key: "showMenu",
    value: function showMenu() {
      if (this.menuActive) {
        return;
      }

      this.menuActive = true;
      this.classList.add('dropdown--active');
      this.retainScrolling();
      this.updateHeight();
    }
  }, {
    key: "hideMenu",
    value: function hideMenu() {
      if (!this.menuActive) {
        return;
      }

      this.menuActive = false;
      this.classList.remove('dropdown--active');
      this.releaseScrolling();
    }
  }]);

  return DropDown;
}(CustomHTMLElement);

export { DropDown as default };
window.customElements.define('drop-down', DropDown);
export function MenuDropDown(anchor, items) {
  var menu = document.createElement('div');
  menu.classList.add('dropdown__menu');
  menu.classList.add('dropdown__menu--list');
  var dropdown;
  items.forEach(function (item) {
    var menuItem = document.createElement('a');
    menuItem.classList.add('dropdown__menu__item');
    menuItem.innerText = item.title;
    menuItem.addEventListener('click', function () {
      dropdown.hideMenu();
      item.action();
    });
    menu.appendChild(menuItem);
  });
  dropdown = new DropDown({
    anchor: anchor,
    menu: menu
  });
  return dropdown;
}